<template>
  <div class="donatees">
    <h2 class="donatees__title">{{ t('efriends.donateesTitle') }}</h2>
    <div class="donatees__list">
      <transition-group name="donatees__list-item" tag="div">
        <div
          v-for="donatee in donatees"
          :key="donatee.cubeName"
          class="donatees__list-item"
        >
          <Donatee :cube="donatee" />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import Donatee from '@/components/efriends/Donatee.vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useCubeStore } from '@/stores/useCubeStore'

  export default {
    name: 'donatees',
    setup(){
      const cubeStore = useCubeStore()
      const { t } = useStrings()
      return {
        t,
        cubeStore,
      }
    },
    components: {
      Donatee,
    },
    computed: {
      consumers() {
        return this.cubeStore.consumers
      },
      producers() {
        return this.cubeStore.producers
      },
      donatees() {
        let donatees = {}
        this.cubeStore.consumers.map((cube) => {
          if (cube.isDonatee) {
            donatees[cube.cubeName] = cube
          }
        })

        this.cubeStore.producers.map((cube) => {
          if (cube.isDonatee) {
            donatees[cube.cubeName] = cube
          }
        })

        return Object.entries(donatees).map((row) => {
          return row[1]
        })
      },
    },
  }
</script>

<style lang="scss">
  .donatees {
    margin: $spacer20 auto 0;
    max-width: 800px;

    &__list {
      &-item {
        transition: all 1s ease-in-out 0s;
        margin: 0;

        &-leave-active {
          max-height: 0;
          padding-top: 0;
          padding-bottom: 0;
          border-width: 0;
          overflow: hidden;
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
</style>
